<template>
  <div id="testimonials-wrapper">
    <div class="testimonials">
      <h2 class="title">They earned with us</h2>
      <div class="block-holder clearfix">
        <b-carousel id="carousel-1" :interval="4000" controls>
          <div v-for='(chunk, i) in chunkedTestimonials' :key='i'>
            <b-carousel-slide>
              <template slot="img">
                <Card :chunk='chunk[0]'/>
                <div v-if='chunk[1]'>
                  <Card :chunk='chunk[1]'/>
                </div>
                <div v-if='chunk[2]'>
                  <Card :chunk='chunk[2]'/>
                </div>
              </template>
            </b-carousel-slide>
          </div>
        </b-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import Card from './Card.vue'

export default {
  name: 'Testimonials',
  components: { Card }, 
  data() {
    return {
      chunkedTestimonials: []
    }
  },
  watch: {
    testimonials() {
      // splits testimonials into chunks of 3 for carousel
      while (this.testimonials.length > 0)
        this.chunkedTestimonials.push(this.testimonials.splice(0, 3))
    }
  },
  apollo: {
    testimonials: gql`
      {
        testimonials {
          id
          Testimonial
          Affiliate
          Url
          Media {
            url
          }
        }
      }
    `
  }
}
</script>

<style>
.carousel-control-prev-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23999' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E") !important;
  position: absolute;
  left: -15px;
}

.carousel-control-next-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23999' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E") !important;
}

.carousel-control-prev,
.carousel-control-next {
  width: 4% !important;
}
</style>

<style scoped>
.testimonials {
  width: 100%;
  padding: 50px;
}

h2.title {
  color: rgb(0, 71, 80);
  font-weight: 300;
  font-size: 64px;
  text-align: center;
  margin-bottom: 40px;
}

.block-holder {
  margin: 0 auto;
  width: 100% !important;
}

.block-aff {
  width: 29%;
  background: rgb(255, 255, 255);
  border-radius: 4px;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.25);
  height: 300px;
  margin-left: 3%;
  float: left;
  padding: 30px;
  position: relative;
  margin-bottom: 20px;
}

@media (max-width: 1600px) {
  .block-holder {
    width: 70%;
  }
}

@media (max-width: 1530px) {
  .block-aff {
    height: auto;
  }
}

@media (max-width: 1200px) {
  .block-holder {
    width: 80%;
  }
}

@media (max-width: 1000px) {
  .testimonials {
    padding: 30px;
  }
  .block-holder {
    width: 90%;
  }
  .block-aff {
    height: unset;
    width: 100%;
  }
}
</style>
